import styles from './footer.module.scss';
import styles_mobile from './footer_mobile.module.scss';
import Link from 'next/link';
import Img from './Img';
import useScreenWidthBelowThreshold from '../hooks/useScreenWidthBelowThreshold';
import { useState } from 'react';
import OneLinkImg from './OneLinkImg';
import { useAndroid } from '../hooks/common';
import { useCmpSafe } from '../stores/CmpContext';

export default function Footer() {
  const [showProduct, setShowProduct] = useState(false);
  const [showCondition, setShowCondition] = useState(false);
  const [showContact, setShowContact] = useState(false);
  const isAndroid = useAndroid();
  const jumpUrl = isAndroid
    ? 'https://play.google.com/store/apps/details?id=next.bondee.tech&hl=en_US'
    : 'https://apps.apple.com/us/app/duet-date-meet-new-friends/id1673723000?mt=8';

  const isScreenWidthBelow700px = useScreenWidthBelowThreshold(1281);
  const cmp = useCmpSafe();

  const handleOpenCookieSettings = (e) => {
    e.preventDefault();
    cmp?.openSettings?.();
  };

  if (isScreenWidthBelow700px) {
    return (
      <div className={styles_mobile.footer}>
        <div className={styles_mobile.title}>Download the Duet App</div>
        <div className={styles_mobile.download}>
          <OneLinkImg src="https://cdn.duetapp.net/v1/images/eyJpZCI6IkRCWk9GSkNWVk5MUVBVSUxXQkxPSTdMQkdERFRJVyIsInciOjI5NCwiaCI6OTAsImQiOjAsIm10IjoiaW1hZ2UvanBlZyIsImRoIjo0OTg1OTk1NzYxNjE5NzUzMjIxfQ" />
          <a href="https://play.google.com/store/apps/details?id=next.bondee.tech" target="_blank" rel="noreferrer">
            <Img src="https://cdn.duetapp.net/v1/images/eyJpZCI6IlNUQklFUUo3QkNUT0lZQjVCUkJXTUtDSzJWNUNCSiIsInciOjI5NCwiaCI6OTAsImQiOjAsIm10IjoiaW1hZ2UvanBlZyIsImRoIjo1MDE3OTMxNDUyMDc1NjUzNDQ1fQ" />
          </a>
        </div>
        <div className={styles_mobile.line} />
        <div className={styles_mobile.link}>
          <div className={styles_mobile.link_title} onClick={() => setShowProduct((value) => !value)}>
            <span>PRODUCT</span>
            <span>{showProduct ? '-' : '+'}</span>
          </div>
          {showProduct && (
            <>
              <div>
                <a href="/matchmaking">Matchmaking</a>
              </div>
              <div>
                <Link href="/features">Features</Link>
              </div>
              <div>
                <Link href="/subscription">Subscription</Link>
              </div>
              <div>
                <Link href="/articles">Blog</Link>
              </div>
            </>
          )}
        </div>
        <div className={styles_mobile.line} />
        <div className={styles_mobile.link}>
          <div className={styles_mobile.link_title} onClick={() => setShowCondition((value) => !value)}>
            <span>CONDITIONS</span>
            <span>{showCondition ? '-' : '+'}</span>
          </div>
          {showCondition && (
            <>
              <div>
                <Link href="/guidelines" target="_blank">
                  Community Guidelines
                </Link>
              </div>
              <div>
                <Link href="/privacy" target="_blank">
                  Privacy
                </Link>
              </div>
              <div>
                <Link href="/refund" target="_blank">
                  Refund Policy
                </Link>
              </div>
              <div>
                <Link href="/cookie-policy" target="_blank">
                  Cookie Policy
                </Link>
              </div>
              <div>
                <a href="#" onClick={handleOpenCookieSettings} className={styles_mobile.cookieSettingsLink}>
                  Cookie Settings
                </a>
              </div>
              <div>
                <Link href="/terms" target="_blank">
                  Terms
                </Link>
              </div>
            </>
          )}
        </div>
        <div className={styles_mobile.line} />
        <div className={styles_mobile.link}>
          <div className={styles_mobile.link_title} onClick={() => setShowContact((value) => !value)}>
            <span>CONTACT</span>
            <span>{showContact ? '-' : '+'}</span>
          </div>
          {showContact && (
            <>
              <div>
                <Link href="/support">Support</Link>
              </div>
              <div>
                <Link href="/legal" target="_blank">Legal</Link>
              </div>
              <div>
                <Link href="/safety" target="_blank">
                  Safety Tips
                </Link>
              </div>
              <div>
                <a target="_blank" href="https://www.instagram.com/duet.app/" rel="noreferrer">
                  Instagram
                </a>
              </div>
              {/* <div>Contact Us: support@duetapp.net </div> */}
            </>
          )}
        </div>
        <div className={styles_mobile.line} />
        <div className={styles_mobile.bottom}>
          <span>© 2026 Wink Tech Limited. All Rights Reserved.</span>
          <Img
            src="https://cdn.duetapp.net/v1/images/eyJpZCI6Ik9HU0dDSFdNNFhQU1lCU0JYRFFTNFk0NFZUMkxNSiIsInciOjIyMCwiaCI6NDQsImQiOjAsIm10IjoiaW1hZ2UvanBlZyIsImRoIjoyNTUyNTk2NjcxMTAyNDIzNjk5fQ"
            alt=""
          />
        </div>
        <div className={styles_mobile.text1}>
          <div>Wink Tech Limited (hereinafter "Duet"): 300 Delaware Avenue, Suite 210‑2207, Wilmington, DE 19801</div>
        </div>
      </div>
    );
  } else {
    return (
      <div className={styles.footer}>
        <div className={styles.footer_left}>
          <a target="_blank" className={styles.button} href={jumpUrl} rel="noreferrer">
            DUET NOW
          </a>
          <div className={styles.text}>
            <span>© 2026 Wink Tech Limited</span>
            <span>All Rights Reserved.</span>
          </div>
          <div className={styles.text1}>
            <span>Wink Tech Limited (hereinafter "Duet"): 300 Delaware Avenue, Suite 210‑2207, Wilmington, DE 19801</span>
          </div>
          <Img
            src="https://cdn.duetapp.net/v1/images/eyJpZCI6IkVSSjc3Q0taU1ZPV1A1QTVDVUFMUzdOSjc2RkNOUCIsInciOjIyMCwiaCI6NDQsImQiOjAsIm10IjoiaW1hZ2UvanBlZyIsImRoIjoyNTUyNTk2NjcxMTAyNDIzNjk5fQ"
            alt=""
          />
        </div>
        <div>
          <div>PRODUCT</div>
          <div>
            <a href="/matchmaking">Matchmaking</a>
          </div>
          <div>
            <Link href="/features">Features</Link>
          </div>
          <div>
            <Link href="/subscription">Subscription</Link>
          </div>
          <div>
            <Link href="/articles">Blog</Link>
          </div>
        </div>
        <div>
          <div>CONDITIONS</div>
          <div>
            <Link href="/guidelines" target="_blank">
              Community Guidelines
            </Link>
          </div>
          <div>
            <Link href="/privacy" target="_blank">
              Privacy
            </Link>
          </div>
          <div>
            <Link href="/refund" target="_blank">
              Refund Policy
            </Link>
          </div>
          <div>
            <Link href="/cookie-policy" target="_blank">
              Cookie Policy
            </Link>
          </div>
          <div>
            <a href="#" onClick={handleOpenCookieSettings} className={styles.cookieSettingsLink}>
              Cookie Settings
            </a>
          </div>
          <div>
            <Link href="/terms" target="_blank">
              Terms
            </Link>
          </div>
        </div>
        <div>
          <div>CONTACT</div>
          <div>
            <Link href="/support">Support</Link>
          </div>
          <div>
            <Link href="/legal" target="_blank">Legal</Link>
          </div>
          <div>
            <Link href="/safety" target="_blank">
              Safety Tips
            </Link>
          </div>
          <div>
            <a target="_blank" href="https://www.instagram.com/duet.app/" rel="noreferrer">
              Instagram
            </a>
          </div>
          {/* <div>Contact Us: support@duetapp.net </div> */}
        </div>
      </div>
    );
  }
}
